/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgCreditCardIcon: FC<IProps> = ({ width = 24, height = 24, color = "#262626" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 10.0863H22M4 5.0863H20C21.1046 5.0863 22 5.98173 22 7.0863V17.0863C22 18.1909 21.1046 19.0863 20 19.0863H4C2.89543 19.0863 2 18.1909 2 17.0863V7.0863C2 5.98173 2.89543 5.0863 4 5.0863Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgCreditCardIcon;
